import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button ,DropdownItem , DropdownMenu ,ButtonGroup,
 Nav , NavItem, Dropdown , DropdownToggle,Label,FormGroup, Input,InputGroup} from 'reactstrap';
 import { TabContent, TabPane,  NavLink, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import ReactTable from "react-table";
import "react-table/react-table.css";


import * as actions from '../../actions/movimientocaclientes';
// import Modal from "./Modal";

import {api} from '../../actions/_request';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import moment from 'moment';
import Select from 'react-select';
import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import ModalTablas from '../../components/catalogos/modal_tablas';
import ProductosModal from "./ProductosModal";
import _ from 'underscore';
// 8410
const options_currency = { style: 'currency',  currency: 'USD'  };
const numberFormatCurrency = new Intl.NumberFormat('en-US', options_currency);

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };
const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);



   
class EmbarqueModal extends React.Component
{
     constructor(props)
    {
        super(props)

        this.state = {
            compra: {
                id:0,
                cliente_id:11551,
                movimiento_id:0,
                factura_id:0,
                importe:'0.00',
                descuento:'0.00',
                subtotal:'0.00',
                ieps:'0.00',
                impuestos:'0.00',
                total:0,
                fecha: moment().format('Y-MM-DD'),
                concepto:'',
                referencia:'',
                tipo:1,
                forma_pago:1,
                rfc_ordenante:'',
                nombre_banco_extranjero:'',
                cuenta_ordenante:'',
                rfc_banco_beneficiario:'',
                cuenta_beneficiario:'',
                tipo_cadena_pago:'',
                correo:'',
                certificado_pago:'',
                cadena_pago:'',
                sello_pago:'',
                tipo_movimiento_id:1,
                tipo_cambio:0,
                exportacion:'01',
                regimen:'',
                codigo_postal:'',
                moneda:"MXN"
                             
            },
            factura:[],
            facturas:[],
            subtotal_documento:"$0.00",
            impuesto_documento:"$0.00",
            saldo_documento:"0.00",
            saldo_proveedor:"$0.00",
            saldo_original:"0.00",
            action: 'save',
            activeTab: '1',          
            /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            /*variables para los campos de busqueda de codigos*/
            proveedor_codigo:'',
            proveedor_descripcion:"",
            factura_codigo:'',
            factura_descripcion:"",
            movimiento_codigo:'',
            movimiento_descripcion:"",
            naturaleza:'',
            motivos:[      {label:'[01] Nota de crédito de los documentos relacionados',value:'01'},
                     {label:'[02] Nota de débito de los documentos relacionados',value:'02'},
                     {label:'[03] Devolución de mercancía sobre facturas o traslados previos',value:'03'},
                     {label:'[04] Sustitución de los CFDI previos',value:'04'},
                     {label:'[05] Traslados de mercancias facturados previamente',value:'05'},
                     {label:'[06] Factura generada por los traslados previos',value:'06'},
                     {label:'[07] CFDI por aplicación de anticipo',value:'07'},
                     {label:'[08] Factura generada por pagos en parcialidades',value:'08'},
                     {label:'[09] Factura generada por pagos diferidos',value:'09'},
              ],
            monedas:[      {label:'Peso (MXN)s',value:'MXN'},
                           {label:'Dolar (USD)',value:'USD'},
              ],

        
           
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
       


        

        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
                 
    }
    handleClose (event) {
        // console.log('evento--->',event)
         
        let {compra} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla="";
        let bandera_proveedor=true;

        
         switch (name) {
            case "factura_codigo":                  
                  campo = "factura_id";
                  tabla="/busqueda_facturas_cliente_abonos/"+compra.cliente_id;
                  if(parseInt(compra.cliente_id)==0)
                    bandera_proveedor=false;

                  break;
            case "proveedor_codigo":                                  
                  campo = "cliente_id";
                  tabla="/busqueda_cliente";                   
                  break;
            case "movimiento_codigo":                 
                  campo = "movimiento_id";
                  tabla="/busqueda_movimiento";
                  break;      
        }
        let self =this;
        if(value!=""&&bandera_proveedor){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        /*aqui va el request para buscar el saldo*/
                        let  retorno=response.data
                         self.retorno(retorno,campo,vaciar,value);                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }                            
                   
                }

            });
        }else{
           if(bandera_proveedor==false){
            swal("Oops..", "Selecciona un Cliente");

          }
            self.retorno([],campo,1,value); 
        }
   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let descripcion="";
        let campo_codigo="";
        let campo_descripcion="";
        let saldo="$0.00";
        let credito="$0.00";
        let bandera=false;
        // console.log('renglon---->',objeto);
         // console.log('campo---->',campo);
        let {compra,facturas} = this.state;
        let self =this;
        
         if(vacio==1){
          // console.log('vaciar')
          codigo=valor;
          descripcion="";
          compra[campo] =0;
         }

         // console.log('descripcion--->',descripcion);

         switch (campo) {
            case "cliente_id":
                if(vacio==1){
                  // console.log('vaciar')
                  compra[campo] =0;
                  self.setState({
                        
                        compra : compra,           
                        proveedor_codigo:valor,
                        proveedor_descripcion:'',
                        saldo_proveedor:'$0.00',
                        modal:false,         
                    }) 
                 }else{
                  compra[campo] = objeto.value?objeto.value:objeto.id;
                  compra.codigo_postal = objeto.codigo_postal?objeto.codigo_postal:objeto.codigo_postal;
                  compra.regimen = objeto.regimen_id?objeto.regimen_id:objeto.regimen_id;
                  compra.cuenta_ordenante = objeto.cuenta?objeto.cuenta:objeto.cuenta;
                  compra.rfc_ordenante = objeto.rfc_banco?objeto.rfc_banco:objeto.rfc_banco;
                  compra.nombre_banco_extranjero = objeto.nombre_banco?objeto.nombre_banco:objeto.nombre_banco;

                  self.setState({
                        
                        compra : compra,           
                        proveedor_codigo:objeto.value?objeto.value:objeto.id,
                        proveedor_descripcion:objeto.label?objeto.label:objeto.nombre,
                        saldo_proveedor:objeto.saldo,
                        modal:false,         
                    }) 

                 }  
                  break;
            case "factura_id":
                      /*validamos que la factura sea de la misma moneda  que el documento*/
                      if(objeto.moneda == compra.moneda){
                      let factura_nueva={
                        id:null,
                        id_complemento:null,
                        factura_id:objeto.value,
                        total_abono:0,
                        abono_documento:0,
                        /*Datos para la tabla */
                        total:objeto.total,
                        moneda:objeto.moneda,
                        tc:objeto.tc,
                        saldo:objeto.saldo_numero,
                        folio:objeto.factura
                      }; 
                      /*validamos que no se agrege dos veces la misma factura */
                      var index = facturas.findIndex(p => p.factura_id == objeto.value);
                      if(index >= 0){
                        swal("Oops..", "La Factura ya esta Agregada");
                      }else{
                        facturas.push(factura_nueva)
                      }
                       self.setState({
                        facturas:facturas,                           
                        modal:false,         
                  })
                }else{
                        swal("Oops..", "La Factura Tiene  que tener la misma Moneda que el Pago");
                      }
                   
                 
                  break;
            case "movimiento_id":
                  if(vacio==1){
                    codigo=valor;
                    descripcion="";
                    compra[campo] =0;
                    compra.tipo =0;
                    self.setState({
                        compra : compra,           
                        movimiento_codigo:valor,
                        movimiento_descripcion:'',
                        naturaleza:'',
                        modal:false,         
                    }) 
                   }  else{
                    compra[campo] = objeto.value?objeto.value:objeto.id;  
                    compra.tipo = objeto.tipo;  
                    compra.concepto= objeto.tipo_nombre;                      
                    self.setState({
                        compra : compra,           
                        movimiento_codigo:objeto.codigo,
                        movimiento_descripcion:objeto.label,
                        naturaleza:objeto.tipo_nombre,
                        modal:false,         
                    }) 

                   }
                  
                  break;    
            case "folio_relacion":
                  self.folio_relacion(objeto);                
                  break; 
        }
        
    }


    folio_relacion=(data)=>{
        let _self = this;

      let{compra} = this.state;

        api().get(`/get_folio_complemento/${data.value}`)
            .then(function(response)
            {             
                // console.log(response)     
                if(response.status === 200)
                { 
                    compra.folio_relacion=response.data.folio;
                    _self.setState({
                        modal:false,
                        compra:compra, 
                            
                    })      
                }
            });





    }
    toggle_modal(index=0,catalogo="",campo=""){
        if(campo=='factura_id'&&parseInt(this.state.compra.cliente_id)==0){
            swal("Oops..", "Selecciona un Cliente");
        }else{
            this.setState({
                modal : !this.state.modal,
                titulo:catalogo,
                tabla_modal:index,
                campo_modal:campo,         
            })
        }  
    }   

    handleSelectChange(select, name) {
        const value = select === null ? null : select.value;
        this.setState({ compra: { ...this.state.compra, [name]: value } }, () => { 
            if(name == "moneda")
                this.calcular_total_abono() 
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

    componentDidMount()
    {
       let self = this;
       api().get('/sat/formas_pago/2')
      .then(function(response)
      {
        if(response.status === 200)
        {
          self.setState({
            formas : response.data
          });
        }
      });
        let {compra} = this.state;
        api().get(`datos_facturacion/1`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {              


                   compra.cuenta_beneficiario=response.data.datos.cuenta;
                   compra.rfc_banco_beneficiario=response.data.banco.rfc;  
                    self.setState({
                          compra: compra,
                    });

                }

            });

           
         api().get('/tipo_cambio_venta')
        .then(function(response)
        {             
          // console.log(response)     
            if(response.status === 200)
            { 
              compra.tipo_cambio = parseFloat(response.data.venta);
               self.setState({
                  compra : compra,
               })
            }

        });


         
        let id = this.props.id;
      
              
        if(id > 0 && id != self.state.compra.id)
        {

            api().get(`movimientocac/${id}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        compra: response.data.movimientoca,
                        action: 'update',
                        factura:response.data.factura,
                        facturas:response.data.lista_facturas,
                        proveedor_codigo:response.data.cliente.codigo,
                        proveedor_descripcion:response.data.cliente.nombre,
                        saldo_proveedor:response.data.cliente.saldo,
                        factura_codigo:response.data.factura.factura,
                        factura_descripcion:response.data.factura.concepto,
                        movimiento_codigo:response.data.movimiento.codigo,
                        movimiento_descripcion:response.data.movimiento.nombre,
                        naturaleza:response.data.movimiento.naturaleza,
                        subtotal_documento:response.data.factura.subtotal,
                        impuesto_documento:response.data.factura.impuesto,
                        saldo_documento:response.data.factura.saldo,
                        saldo_original:response.data.factura.total,
                        productos:response.data.productos
                    });

                }

            });
        }
        else if(id == null && self.state.compra.id)
        {   
            // console.log('Reset Modal');
            self.resetModal();
        }
    }

   

    resetModal(){
        this.setState({
           compra: {
                  id:0,
                cliente_id:0,
                movimiento_id:0,
                factura_id:0,
                importe:'0.00',
                descuento:'0.00',
                subtotal:'0.00',
                ieps:'0.00',
                impuestos:'0.00',
                total:0,
                fecha: moment().format('Y-MM-DD'),
                concepto:'',
                referencia:'',
                tipo:1,
                forma_pago:1,
                rfc_ordenante:'',
                nombre_banco_extranjero:'',
                rfc_banco_beneficiario:'',
                cuenta_ordenante:'',
                cuenta_beneficiario:'',
                tipo_cadena_pago:'',
                correo:'',
                certificado_pago:'',
                cadena_pago:'',
                sello_pago:'',
                tipo_movimiento_id:1,
                tipo_cambio:0,
                moneda:"MXN"
                             
            },
            factura:[],
            facturas:[],
            subtotal_documento:"$0.00",
            impuesto_documento:"$0.00",
            saldo_documento:"0.00",
            saldo_proveedor:"$0.00",
            saldo_original:"0.00",
            action: 'save',
            activeTab: '1',          
            /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            /*variables para los campos de busqueda de codigos*/
            proveedor_codigo:'',
            proveedor_descripcion:"",
            factura_codigo:'',
            factura_descripcion:"",
            movimiento_codigo:'',
            movimiento_descripcion:"",
            naturaleza:'',
        });
        
    }
    calcular_total_abono=()=>{
        let {compra,facturas} = this.state;
        compra.total = 0;
        for (var i = facturas.length - 1; i >= 0; i--) {
            /*validamos que el valor en el input sea  valido*/
            if(!isNaN(parseInt(facturas[i].abono_documento))){
                /*calculamos el total_abono hacia el documento  en base a la moneda del abono y del documento */
                if(compra.moneda == facturas[i].moneda){
                    /*si es la misma moneda se pasa igual */
                     facturas[i].total_abono=parseFloat(facturas[i].abono_documento);
                }else{
                    if(compra.moneda == "MXN" && facturas[i].moneda == "USD" ){
                        facturas[i].total_abono= global.truncar (facturas[i].abono_documento / compra.tipo_cambio,2);
                    }
                    if(compra.moneda == "USD" && facturas[i].moneda == "MXN" ){
                        facturas[i].total_abono= facturas[i].abono_documento * compra.tipo_cambio;
                    }

                }
                compra.total += parseFloat(facturas[i].abono_documento);
            }
        }
        this.setState({ compra:compra,facturas}, () => { });
    }
    handleInputChangeTable = (value, index) =>{
        let {compra,facturas} = this.state;       
        facturas[index].abono_documento=value;
        this.setState({ facturas:facturas}, () => { this.calcular_total_abono() });


    }

    deleteRow=(index)=> {
        let {compra,facturas} = this.state;      
        swal({
              title: 'Estas seguro?',
              text: "Se eliminara la factura de la lista!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Estoy Seguro!',
               cancelButtonText: 'Cancelar!'
            }).then((result) => {
              if (result.value) {
               
                facturas.splice(index, 1);
                this.setState({ facturas:facturas}, () => { this.calcular_total_abono() });
                swal(
                  'Factura',
                  'Eliminada de la lista.',
                  'success'
                )
              }
            })
}
    handleInputChange(event) {
        let {compra,factura} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        compra[name] = value;

        this.setState({ compra:compra}, () => { 
            if(name == "tipo_cambio")
                this.calcular_total_abono() 
        });
    }


   objeto_mayusculas(objeto){
      for (var key in objeto) {
        if (objeto.hasOwnProperty(key)) {                    
          objeto[key] = String(objeto[key]).toUpperCase() ;
          if( String(objeto[key]).toUpperCase()==='NULL')
            objeto[key] ='';
        }
      }
      return objeto;
    }
   
   
handleSubmit(evt){
   evt.preventDefault();
        let {compra,factura,facturas} = this.state;
        if(parseInt(compra.cancelado)==1){
          swal("Oops..", "Movimiento Cancelado ","warning");
          return false;
        } 
        let action=this.state.action;
        
        let save=true;
        let mensaje=true;
        let dato="";
        let self = this;        
        
            // let check = ['referencia','concepto','fecha','rfc_ordenante','nombre_banco_extranjero','rfc_banco_beneficiario','cuenta_beneficiario','tipo_cadena_pago','correo',];
            // if(parseInt(factura.tipo_doc)==2){
             let  check = ['referencia','concepto','fecha'];
            // }

            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
            }
            check = [
            'cliente_id',
            'movimiento_id',
            ];
            if(save)
            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(parseInt( value) == 0) {
                save = false;
                break;
            }
                
            }

            /*validamos que minimo agregen una factura*/
            if(facturas.length > 0){
                /*revisamos que todas las facturas tengan el abono documento mayor a  0*/
                for (var i = facturas.length - 1; i >= 0; i--) {
                    if(isNaN(parseInt(facturas[i].abono_documento)) || parseFloat(facturas[i].abono_documento) == 0){
                        dato=facturas[i].folio;
                        save = false;
                        break
                    }
                    
                }
                if(save == false){
                    swal("Oops..", `Por favor Revisar la factura ${dato} ` );
                    return;
                }

                    
            }else{
                 swal("Oops..", "Por favor Verificar el listado de facturas " );
                 return;
            }
        if(save   ){
            compra.lista_facturas=facturas;

            api().post(`/validacion_movimientocac`, compra)
            .then(function(response)
            {  
               let validacion=response.data.validacion;
                let encontrado=response.data.encontrado[0];
              if(validacion||(parseInt(encontrado.id)===parseInt(compra.id) )){
        
                    self.props[action](compra, (data) => {
                        if(data.estado){

                             self.props.alerta({
                                mensaje:"Cargo / Abono se Guardado correctamente!",
                                tipo:"success",
                                creacion:moment().format('Y-MM-DD H:m:s'),
                              });
                              self.resetModal();
                              self.props.cerrar();

                        }else{
                            self.props.alerta({
                                mensaje:data.mensaje,
                                tipo:"warning",
                                creacion:moment().format('Y-MM-DD H:m:s'),
                              });

                        }

                     
                });
              }else{
                    swal("Oops..", "La referencia ya existe");
                }
            });
        }else{
          
            swal("Oops..", "Por favor Verificar el Campo "+dato );

        }
    }

    render() {
       let {compra,action}=this.state;
         let editar=true;
         if(action=='update')
          editar=false;
 
        return(
        <div className="view">
            <div className="view-header">
                <header className="title text-white">
                    <h1 className="h4 text-uppercase">Movimiento de Abono</h1>
                </header>
            </div>
            <form onSubmit={this.handleSubmit} >
                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="row justify-content-end">
                            <div className="col-3 mb-4">
                              <div className="mr-5 text-right float-right">
                                {
                                  this.props.movimientocaclientes.saving ?
                                    <SubmitLoad /> : 
                                    <div>
                                      <Button color="primary" type="submit"   >
                                      <IconSave />&nbsp;Guardar
                                      </Button>{' '}
                                      <Button color="secondary" onClick={this.props.cerrar}>
                                      Cancelar
                                      </Button>
                                    </div>
                                } 
                              </div>
                            </div>
                          </div>
                          <Row>
                                <Col sm = "12">
                                    <div className="row form_cliente">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-4"> 
                                                    <div className="form-group">
                                                        <label className="d-block">Cliente *:</label>
                                                        <Input placeholder="" type="number" name="proveedor_codigo" value={this.state.proveedor_codigo} onChange={ this.ChangeCode} onBlur={this.handleClose}
                                                        className="input_button" disabled={!editar}  required />
                                                        <Button onClick={ (button) => { this.toggle_modal(30,"Clientes","cliente_id") } } disabled={!editar}>...</Button>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 pt-4">
                                                    <label className="">{this.state.proveedor_descripcion}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-5"> 
                                                    <div className="form-group">
                                                        <label className="d-block">Movimiento *:</label>
                                                        <Input placeholder="" type="text" name="movimiento_codigo" value={this.state.movimiento_codigo} onChange={ this.ChangeCode} onBlur={this.handleClose} className="input_button" disabled={!editar} required />
                                                        <Button onClick={ (button) => { this.toggle_modal(28,"Tipos de Movimiento","movimiento_id") }  } disabled={!editar}>...</Button>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 pt-4">
                                                    <label className="d-block">Movimiento: {this.state.movimiento_descripcion}</label>
                                                    <label className="d-block">Naturaleza: {this.state.naturaleza}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <div className="col-md-2">
                            <div className="form-group">
                                <label className>Fecha *:</label>
                                <input
                                    type="date" 
                                    className="form-control"
                                    name="fecha"
                                    value={compra.fecha || ''}
                                    onChange={this.handleInputChange}
                                    required
                                   
                                />
                            </div>
                        </div>
                                 <div className="col-md-2">
                            <FormGroup>
                                <Label>Referencia *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="referencia"
                                    maxLength={25}
                                    value={compra.referencia} 
                                    onChange={this.handleInputChange}
                                    required  />
                            </FormGroup>
                        </div>
                        <div className="col-md-2"> 
                            <div className="form-group">
                                <label >Moneda:</label>
                                <Select placeholder="" type="text"  name="moneda" disabled={this.state.facturas.length > 0} options={this.state.monedas}  value={compra.moneda}  onChange={ (select) => { this.handleSelectChange(select, 'moneda',1) } } clearable={false} />
                            </div>
                        </div>
                        <div className="col-2"> 
                                <div className="form-group">
                                    <label className>Tipo Cambio *:</label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="tipo_cambio"
                                    value={compra.tipo_cambio}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                                </div>
                            </div>
                          <div className="col-4"> 
                                <div className="form-group">
                                    <label className>Forma de Pago *:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="forma_pago"
                                        options={this.state.formas}
                                        value={parseInt(compra.forma_pago) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'forma_pago') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                        <div className="col-md-12">
                            <FormGroup>
                                <Label>Concepto *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="concepto"
                                    maxLength={75}
                                    value={compra.concepto} 
                                    onChange={this.handleInputChange}
                                    required  />
                            </FormGroup>
                        </div>
                        <div className="col-12 titulo_subdivision mt-2"> 
                            <h1 className='mb-2 titulo_subdivision'><span>Complemento Relacionado</span></h1> 
                        </div> <br/>
                        <div className="col-md-5"> 
                            <div className="form-group">
                                <label >Motivo *:</label>
                                <Select placeholder="" type="text"  name="relacion_motivo" options={this.state.motivos}  value={compra.relacion_motivo}  onChange={ (select) => { this.handleSelectChange(select, 'relacion_motivo',1) } } clearable={false} />
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6"> 
                            <label className="">Complemento  </label><br/>
                            <div style={{display : 'flex'}}>
                                <input placeholder="" type="text"  name="folio_relacion" value={compra.folio_relacion}  className="input_factura" style={{width: '80%', 'marginBottom': '12px'}} readOnly  required  />
                                <Button style={{height: '33px'}} onClick={ (button) => { this.toggle_modal(37,"Complementos","folio_relacion") } } >...</Button>
                            </div>
                        </div>
                        <div className="col-12 titulo_subdivision mt-2"> 
                            <h1 className='mb-2 titulo_subdivision'><span>Facturas Relacionadas</span></h1> 
                        </div> <br/>
                        <Col className='text-right mb-2'>
                             <h4 className='mb-2 d-inline-block mr-2 '>Total Abono: {numberFormatCurrency.format(Number.parseFloat(compra.total).toFixed(4) )}</h4> 
                             <Button color="info" onClick={ (button) => { this.toggle_modal(32,"Facturas","factura_id") } } >Agregar</Button>
                        </Col>
                        <Col xs='12' >
                            <table className="table tabla_items">
                                <thead>
                                    <tr>
                                        <th width="100px" >Controles</th>
                                        <th>Folio</th>
                                        <th>Saldo</th>
                                        <th>Moneda</th>
                                        <th>TC</th>
                                        <th>Total Abono</th>
                                        <th width="200px">Abono Documento</th>
                                    </tr>
                                </thead>
                                <tbody className="">
                                    {this.state.facturas.map((item, i) => 
                                        <tr key={i}>
                                            <td>
                                                <ButtonGroup> <Button color="danger" onClick={this.deleteRow.bind(this, i)}> X </Button> </ButtonGroup>

                                            </td>
                                            <td>{item.folio}  </td>
                                            <td>{numberFormatCurrency.format(Number.parseFloat(item.saldo).toFixed(4) )}  </td>
                                            <td>{item.moneda}  </td>
                                            <td>{item.tc}  </td>
                                            <td>{numberFormatCurrency.format(Number.parseFloat(item.total_abono).toFixed(4) )}  </td>
                                            <td>
                                                <Input type="number" name="abono_documento" value={item.abono_documento} 
                                                onChange={ (e) => _.debounce(this.handleInputChangeTable(e.target.value, i), 1000) } />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Col>
                          </Row>
                          <div className="row justify-content-end">
                            <div className="col-3 mb-4">
                              <div className="mr-5 text-right float-right">
                                {
                                  this.props.movimientocaclientes.saving ?
                                    <SubmitLoad /> : 
                                    <div>
                                      <Button color="primary" type="submit"   >
                                      <IconSave />&nbsp;Guardar
                                      </Button>{' '}
                                      <Button color="secondary" onClick={this.props.cerrar}>
                                      Cancelar
                                      </Button>
                                    </div>
                                } 
                              </div>
                            </div>
                          </div>
                          <br/>
                          <br/>
                          <br/>
                        </CardBlock>
                    </Card>
                </div>
            </form>
            { this.state.modal&&
                <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    cliente_id={this.state.compra.cliente_id}
                    tipo_movimiento_id={1}  />
            }
        </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        movimientocaclientes : state.movimientocaclientes,
         notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(EmbarqueModal)


// WEBPACK FOOTER //
// ./src/views/movimientoscaclientes/abono.js